import React from 'react';
import PropTypes from 'prop-types';

import AccessibleIcon from '../../common/AccessibleIcon';

const propTypes = {
    text: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    active: PropTypes.bool,
};

const defaultProps = {
    text: '',
    active: false,
};

function ActionListItem(props){
    let className = "nav-list-item action db3NavAction";
    if (props.active) {
        className += " active";
    }
    if (props.extraClasses) {
        className += (" " + props.extraClasses);
    }

    return (
        <div
            onClick={props.onClick}
            className={className}
        >
            <AccessibleIcon className={props.iconClass||"fa"} label={props.text}/>
            <span className="item-text">{props.text}</span>
        </div>
    );
}

ActionListItem.propTypes = propTypes;
ActionListItem.defaultProps = defaultProps;

export default ActionListItem;